class AccountSettings.ConversationAttributesEditorView extends Backbone.View
  template: JST['backbone/templates/account_settings/conversation_attributes/editor']
  blank_model: Backbone.Model.extend({})

  events:
    'change #attribute_type_name': '_onChangeType'
    'focusout #name': '_fillCode'

  initialize: ({isNew, model, collection}) ->
    @isNew = isNew
    @model = model
    @editor = null
    @collection = collection
    @availableTypes = @collection.availableTypes
    @readonlyFields = @collection.readonlyFields
    @modal = @_getModal()
    @modalView = new App.ModalView
      instance: @

  render: ->
    @$el.html @template
      attribute: @model
      availableTypes: @availableTypes
      isNew: @isNew
    @_findFieldsInDOM()
    @_onChangeType()
    @_addTags()
    @_disableButtonsIfNeeded()
    @modalView.firstTab._activate()
    @$el.find('#xls_input').fileupload
      autoUpload: false
      url: '/keepcon/settings/account_setting/conversation_attribute_definitions/upload_xls'
      add: @add
    @_hierarchicalTagsJsonEditor()
    @

  _findFieldsInDOM: ->
    @nameField = @$('#name')
    @codeField = @$('#code')
    @multipleField = @$('#attribute-multiple-true')
    @attributeTypeField = @$('#attribute_type_name')

  add: (_, data) =>
    @$el.find('#xls_confirm').show()
    @data = data
    if @data.files and @data.files[0]
      @$el.find('#xls_input_value').html(data.files[0].name || '')
      reader = new FileReader()
      reader.onload = (event) =>
    reader.readAsDataURL(data.files[0])
    @_uploadXls()

  _onChangeType: =>
    @$('#tags_container').toggle @_tagsAreAllowed()
    @$('#multiple-radio-button').toggle @_shouldShowMultipleSelector()
    @_updateHierarchicalTagsEditor()

  _shouldShowMultipleSelector: ->
    @attributeTypeField.val() in @typesAllowingMultipleAttribute

  typesAllowingMultipleAttribute: [
    'FreeText'
    'FixedString'
    'Date'
    'Integer'
    'Email'
    'Decimal'
  ]

  _fillCode: =>
    if _.isEmpty(@codeField.val().trim())
      @codeField.val(@nameField.val().replace(/[^\w_]/g, '_').toLowerCase())

  _tagsAreAllowed: ->
    @attributeTypeField.val() == 'FixedString'

  exit: =>
    @modalView.destroy()
    @remove()
    false

  save: =>
    if @validate()
      @saveToServer()

  validate: =>
    success = true
    for element in [@nameField, @codeField]
      if _.string.isBlank(element.val())
        element.addClass('error')
        success = false
      else
        element.removeClass('error')
    @_hideHierarchicalTagsError()
    if @_hierarchicalTagsAreAllowed()
      result = @_validateHierarchicalTags()
      unless result.success
        success = false
        @_showHierarchicalTagsError(result.messages)
    return success

  activate: =>
    @modalTab._activate()

  saveToServer: ->
    duplicatedElement = @collection.findWhere({code: @codeField.val()})
    if duplicatedElement && (duplicatedElement.id != @model.id)
      swal({
          title: I18n.t('monitoring.conversation_attributes.errors.code_has_been_taken')
          type: 'info'
          showCancelButton: false
          confirmButtonClass: 'btn-success'
          closeOnConfirm: true
       })
      return false
    @modalView.disableAll()
    @model.save(@_serialize(), { success: @updateModel })

  updateModel: (model, data) =>
    if data.error
      showError(data.error)
      @modalView.enableAll()
      @_disableButtonsIfNeeded()
      return
    if @isNew
      @collection.add(model)
    else
      model.set(data)
    @exit()

  _uploadXls: =>
    @data.process().done () => @data.submit().done (event) =>
      @$el.find('#hierarchical_tags').html(event.json)
      @$el.find('#xls_errors').html(event.errors.toString().replace(new RegExp(",", "g"), '</br>'))

  _addTags: ->
    keywordList = new Monitoring.Collections.SortableKeywordsCollection()
    keywordList.reset(@model.get('tags'));
    @keywordsView = new Monitoring.Views.SortableKeywordView
      keywords: keywordList
      entityName: 'keepcon_settings_account_setting'
      attributeName: 'charts_settings'
      placeholder: 'Add tags'
      keywordId: 'tags-cbo'
    @$el.find('#tags').html(@keywordsView.render().el)

  _disableButtonsIfNeeded: ->
    @_disableReadOnlyButtons() unless @isNew

  _disableReadOnlyButtons: ->
    idsToDisable = [@readonlyFields..., 'attribute-multiple-true', 'attribute-multiple-false']
    @$("##{id}").prop('disabled', true) for id in idsToDisable
    @$el.find('.btn-group').addClass('disabled')

  _serialize: ->
    name: @nameField.val()
    code: @codeField.val()
    multiple: @_shouldShowMultipleSelector() and @multipleField.is ':checked'
    attribute_type_name: @attributeTypeField.find('option:selected').val()
    order: if @isNew then @collection.size() - 1 else @collection.indexOf(@model)
    tags_attributes: @keywordsView.getKeywordsAttributes() if @_tagsAreAllowed()
    hierarchical_tags: @_hierarchicalTagsConfig().toJSON() if @_hierarchicalTagsAreAllowed()

  _getModal: ->
    {
      title: I18n.t("monitoring.conversation_attributes.editor.title.#{if @isNew then 'new' else 'edit'}")
      buttons: [
        {
          title: I18n.t('monitoring.conversation_attributes.editor.cancel'),
          event: 'exit'
        },
        {
          title: I18n.t('monitoring.conversation_attributes.editor.save'),
          event: 'save'
        },
      ]
    }

  _updateHierarchicalTagsEditor: =>
    if @_hierarchicalTagsAreAllowed()
      @_hierarchicalTagsTextAreaContainer().show()
      @$el.find('#xls_button').show()
    else
      @_hierarchicalTagsTextAreaContainer().hide()
      @$el.find('#xls_button').hide()

  _hierarchicalTagsAreAllowed: ->
    @attributeTypeField.val() == 'HierarchicalTags'

  _validateHierarchicalTags: =>
    try
      config = @_hierarchicalTagsConfig()
    catch error
      return {success: false, messages: error.message}
    config.validate()

  _hierarchicalTagsConfig: =>
    config = JSON.parse(@_hierarchicalTagsValue())
    new AccountSettings.ConversationAttributes.HierarchicalTagConfig(config)

  _hierarchicalTagsValue: =>
    @_hierarchicalTagsTextArea().val()

  _showHierarchicalTagsError: (messages) =>
    if _.isArray(messages)
      _.forEach(messages, @_hierarchicalTagsAddError)
    else
      @_hierarchicalTagsAddError(messages)
    @_hierarchicalTagsTextArea().addClass('error')

  _hideHierarchicalTagsError: =>
    @_hierarchicalTagsClearErrors()
    @_hierarchicalTagsTextArea().removeClass('error')

  _hierarchicalTagsJsonEditor: =>
      textboxconfig = @_hierarchicalTagsTextArea();
      json_value = @_hierarchicalTagsValue() || "{}"
      if @editor then @editor.destroy()

      options = {
        modes: ['code', 'tree'],
        mode: 'tree',
        onChangeText: (jsonString) =>
          textboxconfig.val(jsonString)
      }

      container = @$el.find(".jsoneditor-container")[0]
      @editor = new JSONEditor(container, options);
      @editor.setText(json_value);
      @editor

  _hierarchicalTagsTextArea: =>
    @$el.find('#hierarchical_tags')

  _hierarchicalTagsTextAreaContainer: =>
    @$el.find('#hierarchical_tags_container')

  _hierarchicalTagsAddError: (err) =>
    @_hierarchicalTagsErrorsContainer().append(@_hierarchicalTagsError(err))

  _hierarchicalTagsClearErrors: =>
    @_hierarchicalTagsErrorsContainer().empty()

  _hierarchicalTagsErrorsContainer: =>
    @$el.find('#hierarchical_tags_errors')

  _hierarchicalTagsError: (message) ->
    "<p>#{message}</p>"
